import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import delay from 'delay';
import getOnboardingTasks from 'fetches/getOnboardingTasks';
import * as Types from 'pages/Pages/typings';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CancelButton from 'components/Page/CancelButton';
import SlideContent from './SlideContent';
import LoadingButton from 'atoms/LoadingButton';

interface Props {
  loading: boolean;
  onSave: (data: Types.NewEntityType) => void;
  onSetOpen: (status: boolean) => void;
  setSlideIndex: (slideIndex: number) => void;
}

function IndependentSlide({ loading, onSave, onSetOpen, setSlideIndex }: Props) {
  const dispatch = useDispatch();
  const [independentPageTypeName, setIndependentPageTypeName] = useState<string | undefined>('');
  const handleIndependentPageTypeNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIndependentPageTypeName(e.target.value);
  };

  const handleCreateIndependentPage = async () => {
    independentPageTypeName &&
      onSave({
        name: independentPageTypeName,
        newPersonFieldType: null,
        convertPersonField: null,
        parentFieldId: null,
      });

    await delay(8000);
    dispatch(getOnboardingTasks());
  };

  return (
    <SlideContent
      actions={
        <>
          <CancelButton disabled={loading} onClick={() => setSlideIndex(0)} />
          <LoadingButton
            color="secondary"
            disabled={independentPageTypeName === ''}
            loading={loading}
            label="Create Page Type"
            onClick={handleCreateIndependentPage}
          />
        </>
      }
      lastSlideIndex={0}
      renderBackIcon
      slideTitle="Create New Independent Pages"
      onSetOpen={onSetOpen}
      setSlideIndex={setSlideIndex}
    >
      <div>
        <Typography variant="h6">Page Type Name</Typography>
        <Typography variant="subtitle2">
          What type of things do these pages represent? For example: 'Project', 'Award', etc.
        </Typography>
      </div>
      <TextField
        id="independent-page-type-name-input"
        fullWidth
        value={independentPageTypeName}
        onChange={handleIndependentPageTypeNameChange}
        inputProps={{ 'aria-label': 'independent page type name input' }}
      />
    </SlideContent>
  );
}

export default IndependentSlide;
